export const columnSchema = [
  { width: 200, field: 'street', displayName: 'Street', type: 'string' },
  { width: 112, field: 'city', displayName: 'City', type: 'string' },
  { width: 80, field: 'county', displayName: 'County', type: 'string' },
  { width: 50, field: 'state', displayName: 'State', type: 'string' },
  { width: 65, field: 'zipcode', displayName: 'Zipcode', type: 'string' },
  { width: 150, field: 'latitude', displayName: 'Latitude', type: 'number' },
  { width: 150, field: 'longitude', displayName: 'Longitude', type: 'number' },
  { width: 100, field: 'asgPropID', displayName: 'PM ID', type: 'number' },
  { width: 200, field: 'comment', displayName: 'Comment', type: 'string' },
];